// @ts-nocheck

import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';

import ContactFormLite from 'app/shared/modules/hdp/form/Contact/ContactFormLite';
import Interstitial from 'app/shared/modules/hdp/ZillowApplicationsFlow/Interstitial';
import { useToolTip } from './hooks';
import { shouldShowApplyButton } from 'app/shared/utils/cometUtils';
import { emitTrackRentalAppPreStartEvent } from 'app/shared/models/Clickstream/HdpClickstreamEvents';
import { getListingType, getTrackingFunction } from 'app/shared/utils/clickstreamUtils';
import constants from 'app/shared/constants/ExperimentConstants';
import { useModal } from 'app/shared/contexts/ModalContext/useModal';

const ZillowApplicationPopup = ({ onActionPopup, onHidePopup }) => {
  const modal = useModal();
  const listing = useSelector((state) => state.currentListingDetails.currentListing);
  const similarListings = useSelector((state) => state.fetchListing.similarListings);
  const isMobile = useSelector((state) => state.app.device.isMobile);
  const isApplyInstantlyExperiment = useSelector(
    (state) => state?.analytics?.runningExperiments?.[constants.HOTPADS_WEB_APPLY_INSTANTLY]?.isControl === false,
  );

  const [showToolTip, toggleToolTip] = useToolTip();

  const handleInterstitialApplyClick = useCallback(() => {
    emitTrackRentalAppPreStartEvent();
  }, []);

  const handleToolTipClick = useCallback(() => {
    toggleToolTip(!showToolTip);
  }, [showToolTip, toggleToolTip]);

  const handleContactFormTracking = useCallback(() => {
    const listingType = getListingType(listing);

    getTrackingFunction({ type: listingType })?.({
      listing: listing,
      triggerObject: 'home_details_component|modal_contact_form',
      triggerSource: 'button_to_complete_request_to_apply_form',
    });
  }, [listing]);

  const { rentalApplicationStatus } = listing;
  const acceptsApplications = shouldShowApplyButton(rentalApplicationStatus);

  // For contact forms, immediately close this modal and open via new system
  useEffect(() => {
    if (!acceptsApplications) {
      // Close the old modal immediately
      onHidePopup();

      // Open contact modal using new modal system for consistent body lock behavior
      modal.openModal({
        type: 'contact',
        props: {
          listing,
          similarListings,
          customForm: ContactFormLite,
          customTracking: handleContactFormTracking,
          onShowSuccessModal: onActionPopup,
        },
      });
    }
  }, []); // Only run once on mount

  // Only render application flow if accepting applications
  if (!acceptsApplications) {
    return null; // New modal system handles the contact form
  }

  return (
    <Interstitial
      handleToolTipClick={handleToolTipClick}
      showToolTip={showToolTip}
      handleInterstitialApplyClick={handleInterstitialApplyClick}
      propertyId={listing.aliasEncoded}
      isMobile={isMobile}
      isApplyInstantlyExperiment={isApplyInstantlyExperiment}
    />
  );
};

export default ZillowApplicationPopup;
